var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cells"},[_c('div',{staticClass:"cells-dc"},[_c('div',{staticClass:"cells-left"},[_vm._v(" "+_vm._s(_vm.electric)+" ")]),_c('div',{staticClass:"cells-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }